import React from "react";
import styled from "styled-components";
import MainWrapper from "src/components/Mainwrapper.js";
import Img from "gatsby-image";
import { Link } from "gatsby";
import slugify from "slugify";

import colors from "src/assets/styles/colors.js";
import typographySizes from "src/assets/styles/typographySizes.js";
import Button from "src/components/Global/ButtonEx.js";
import distances from "src/assets/styles/distances.js";
import noHangers from "src/assets/fn/noHangers.js";

import mediaQuery from "src/assets/styles/mediaQuery.js";
import Body from "src/components/Typography/Body.js";
import Instagrm from "src/assets/svg/instagram.inline.svg";

const Wrapper = styled.footer`
  padding-top: 50rem;
  background-color: ${colors.grey};
  overflow: hidden;
  @media (max-width: ${mediaQuery.tablet}) {
    padding-top: 40rem;
  }
`;

const StyledWrapper = styled(MainWrapper)`
  display: grid;

  grid-template-columns: 8.33% 58.33% 8.33% 25%;
  grid-template-rows: auto;
  font-size: 10rem;
  grid-template-areas:
    ". mainInfo . logo"
    ". mainInfo . img "
    ". subInfo . img";
  @media (max-width: ${mediaQuery.desktop}) {
    grid-template-columns: 66.66% 8.33% 25%;
    grid-template-areas:
      " mainInfo . logo"
      " mainInfo . img "
      " subInfo . img";
  }
  @media (max-width: ${mediaQuery.tablet}) {
    grid-template-columns: 50% 50%;
    grid-template-areas:
      "mainInfo mainInfo"
      "logo subInfo"
      "img img";
  }
`;

const MainInfo = styled.div`
  grid-area: mainInfo;
`;

const Title = styled.h3`
  color: ${colors.dark};
  font-size: ${typographySizes.m}rem;
  margin-bottom: 20rem;
`;

// const SubTitle = styled.h4`
//   color: ${colors.dark};
//   font-size: ${typographySizes.sm}rem;
//   margin-bottom: 50rem;
//   max-width: 350rem;
//   @media (max-width: ${mediaQuery.tablet}) {
//     margin-bottom: 40rem;
//   }
// `;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StyledButton = styled.div`
  margin-right: 40rem;
  margin-bottom: 40rem;
  @media (max-width: ${mediaQuery.tablet}) {
    margin-right: 20rem;
    margin-bottom: 20rem;
    &:last-of-type {
      margin-right: 0;
    }
  }
`;

const PrivacyPolicy = styled(Link)`
  color: ${colors.dark};
  font-size: ${typographySizes.s}rem;
  opacity: 1;
  margin-top: 0rem;
  display: inline-block;
  text-decoration: none;
  margin-left: 15rem;
  text-decoration: underline;
  @media (max-width: ${mediaQuery.tablet}) {
    margin-top: 5rem;
    margin-left: 0rem;
  }
`;

const Logo = styled.div`
  grid-area: logo;
  width: 150rem;

  @media (max-width: ${mediaQuery.tablet}) {
    margin-top: 40rem;
    position: relative;
  }
`;

const SubInfo = styled.div`
  grid-area: subInfo;
  font-size: ${typographySizes.s}rem;
  margin-top: 40rem;
  display: flex;
  justify-content: space-between;
  padding-bottom: 30rem;
  opacity: 0.6;
  flex-wrap: wrap;
  .instagram {
    margin-left: 15rem;
    margin-right: 15rem;
    display: inline-block;
    line-height: 0;
    position: relative;
    top: 5rem;
    transform: scale(1.3);
  }
  @media (max-width: ${mediaQuery.tablet}) {
    flex-direction: column;
    margin-top: 40rem;

    .instagram {
      margin-left: 0rem;
      display: block;
      margin-top: 10rem;
      margin-bottom: 20rem;
      transform: scale(1);
    }
  }
`;

const We3 = styled(Body)`
  margin-top: 10rem;
  display: block;
  width: 100%;
  opacity: 0.5;
  @media (max-width: ${mediaQuery.tablet}) {
    margin-top: 20rem;
  }
`;

const ImgWrapper = styled.div`
  grid-area: img;
  position: relative;
  align-self: end;
  width: 50%;
  margin-left: 50%;
  /* right: ${-distances.pageMarginBig * 2}rem; */
  @media (max-width: ${mediaQuery.tablet}) {
    width: 90%;
    margin-left: 0%;
  }
`;

const FooterImg = styled(Img)`
  width: calc(100% + ${distances.pageMarginBig}rem);
  margin-top: auto;
`;

const Footer = ({ logo, img, links, lang, privacyPolicy }) => {
  const privacyPolicyLink = `${lang == "pl" ? "/" : `/${lang}/`}${slugify(
    privacyPolicy,
    {
      lower: true,
      strict: true,
    }
  )}`;
  return (
    <Wrapper>
      <StyledWrapper>
        <MainInfo>
          <Body>
            <ButtonsWrapper>
              {links.map((linkInfo) => (
                <StyledButton>
                  <Button href={linkInfo.Link}>{linkInfo.Name}</Button>
                </StyledButton>
              ))}
            </ButtonsWrapper>
          </Body>
        </MainInfo>

        <Logo>
          <Img
            objectFit="contain"
            fluid={logo.localFile.childImageSharp.fluid}
          />
        </Logo>

        <SubInfo>
          <Body>
            © 2022 by{" "}
            <a href="https://moxom.pl/" target="_blank">
              moxom
            </a>
            <a
              className="instagram"
              href="https://www.instagram.com/moxom_pl/"
              target="_blank"
            >
              <Instagrm />
            </a>
            All rights reserved!{" "}
            <PrivacyPolicy to={privacyPolicyLink}>
              {privacyPolicy}
            </PrivacyPolicy>
          </Body>
          <We3>
            Design & development:{" "}
            <a href="https://we3studio.pl/" target="_blank">
              we3studio
            </a>
          </We3>
        </SubInfo>
        <ImgWrapper>
          <FooterImg fluid={img.localFile.childImageSharp.fluid} />
        </ImgWrapper>
      </StyledWrapper>
    </Wrapper>
  );
};

export default Footer;
